<template>
    <div id="app">
      <!--导航-->
      <!--<Nav></Nav>-->

      <!--路由的内容显示在router-view-->
      <router-view></router-view>


    </div>
</template>

<script>
  //引入导航组件
  // import Nav from './components/Nav/Nav'

  export default {
        name: "APP",

        // components:{
        //   Nav
        // }
    }
</script>

<style scoped lang="stylus" ref="stylesheet/stylus">

</style>



// WEBPACK FOOTER //
// src/App.vue